import React from 'react';
// components
import LoginForm from '../../components/Form/LoginForm';
import LoginPageImage from '../../components/Background/Login-Signup-Image';
// react-bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Login = () => {
  return (
    <Container className={'mt-5'}>
      <Row>
        <Col xs={12} md={12} lg={6} className={'mt-5'}>
          <LoginPageImage />
        </Col>
        <Col xs={12} md={12} lg={6} className={'mt-5'}>
          <LoginForm />
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
